import React from "react";
import { Separator } from "../../../../components";
import { getGatewayScoreColorAndDesc } from "../utils";
import clsx from "clsx";
import { PremiumSVG } from "../../../../assets";

interface BulletListProps {
  title: string;
  score?: number;
  icon?: React.ReactNode;
  list: { text: string; description?: string }[];
  premium?: boolean;
}

export const BulletList = ({
  title,
  icon,
  list,
  score,
  premium,
}: BulletListProps) => {
  const { color: gatewayScoreBgColor } = getGatewayScoreColorAndDesc(score);

  return (
    <div className="flex flex-col bg-[#55A6FB1A] p-5 rounded-xl gap-4 flex-1">
      <div className="text-[16px] font-medium mb-2 flex items-center gap-2 justify-between">
        <span className="font-medium flex items-center wrap">
          {title}
          {premium && (
            <span className="ml-2">
              <PremiumSVG />
            </span>
          )}
        </span>
        {score && (
          <div
            className={clsx(
              "px-2 py-[6px] rounded-md font-medium",
              gatewayScoreBgColor && `bg-[${gatewayScoreBgColor}]`,
            )}
          >
            {score}
          </div>
        )}
      </div>
      <ul className="list-none">
        {list.map((risk, index) => (
          <React.Fragment key={index}>
            <li className="text-[14px] text-white flex items-center gap-3">
              {icon && <span className="h-5">{icon}</span>}
              <div className="flex flex-col">
                <span>{risk.text}</span>
                <span>{risk.description}</span>
              </div>
            </li>
            {index < list.length - 1 && <Separator className="my-3" />}
          </React.Fragment>
        ))}
      </ul>
    </div>
  );
};
